/**
 * 한국어 원문 → 영문 사전.
 *
 * 키는 컴포넌트에 있던 한국어 문구를 **글자 그대로** 쓴다(띄어쓰기·마침표·오타 포함).
 * 키가 없으면 t()가 한국어 원문을 그대로 돌려주므로 화면이 깨지지 않고,
 * 개발 모드에서는 콘솔에 누락 경고가 한 번 찍힌다.
 *
 * ⚠️ 원문 문구를 수정하면 여기 키도 같이 고쳐야 한다.
 */
const en = {
    // ─────────────────────────────────────────── 공통
    "지도 보러가기": "Open the map",
    "3D 웹사이트 보러가기": "Visit the 3D site",
    "컨설팅 받아보기": "Request consulting",
    "로그인 후 이용가능합니다.": "Please log in to use this feature.",
    "프롭메이트 로고": "PROPMATE logo",

    // ─────────────────────────────────────────── 랜딩 Section01 / MSection01
    "집을 짓는 새로운 방식, 프롭메이트": "A new way to build. PROPMATE.",
    "오직 당신만을 위한 최적화된 디자인": "A design optimized for you alone",
    "단 하나의 디자인을 만들어 냅니다. 고객 만족을 최우선으로한 프롭메이트만의 디자인을 체험해보세요.":
        "We create a single design, made for you. Experience design that puts your satisfaction first.",
    "엄선된 전문 업체로 최상의 시공성": "Hand-picked specialists, best-in-class construction",
    "다양한 포트폴리오를 가진 최고의 업체와 함께합니다. 그들의 작품을 감상해보세요.":
        "We work with leading firms with deep portfolios. Take a look at their work.",
    "고객 예산에 맞춘 금융 컨설팅": "Financial consulting built around your budget",
    // 아래 두 줄은 띄어쓰기만 다른 별개 원문이다(Section01 / MSection01).
    "고객 예산안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.":
        "Find the best way to put your budget to work. We are here to advise you at any time.",
    "고객 예산 안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.":
        "Find the best way to put your budget to work. We are here to advise you at any time.",

    // ─────────────────────────────────────────── 랜딩 Section02 / MSection02
    "지도 기반 토지정보 확인 시스템": "Map-based land information system",
    "원하는 땅을 찾아보세요": "Find the land you are looking for",
    "원하는 땅을 찾아보세요.": "Find the land you are looking for.",
    "얼마에 어떤 건물을 지을 수 있는지 직접 확인하세요.":
        "See for yourself what you can build, and at what cost.",
    "언제 어디서나, 3D Viewer": "Anywhere, anytime — 3D Viewer",
    "언제 어디서나, 3D Veiwer": "Anywhere, anytime — 3D Viewer",
    "Web기반의 3D뷰어로,": "With a web-based 3D viewer,",
    "언제 어디서나 여러분의 계획안을 직관적으로 확인하세요.":
        "review your plans at a glance, wherever you are.",
    "집 짓는데 필요한 필수 정보 컨설팅": "Consulting on everything you need to build",
    "집을 짓기에 필요한 수많은 궁금증": "However many questions building raises,",
    "언제든 물어보고 결정하세요.": "ask them any time, then decide.",
    // MSection02는 제목을 <br/>로 끊어 두 조각으로 쓴다.
    "언제 어디서나,": "Anywhere, anytime —",
    "집 짓는데 필요한": "Consulting on everything",
    "필수 정보 컨설팅": "you need to build",
    "확인 시스템": "system",

    // ─────────────────────────────────────────── 랜딩 Section03 / MSection03
    "지도 기반 토지정보": "Map-based land information",
    "원하는 땅을 직접 찾아보세요.": "Search for the land you want, yourself.",
    "토지가 가진 토지 이용 규제정보, 각종 법령 정보를":
        "Land-use restrictions and the statutes that apply to a site",
    "종합하여 클릭만으로 쉽게 확인해볼 수 있습니다.":
        "are brought together, so a single click shows you all of it.",
    "대한민국 어디든 원하는 땅을 찾아,": "Pick any site in Korea",
    "땅이 가진 정보를 눈으로 확인해 보세요.":
        "and see what that land holds with your own eyes.",
    "원하는 토지에 어떤 건축물을 지을 수 있는지,": "What you may build on it,",
    "어느 정도 규모의 건물을 건축할 수 있는지,": "how large that building may be,",
    "해당 크기의 건축을 하려면 어느 정도의 비용이 소요되는지,":
        "what construction at that size would cost,",
    "초기 건축 자본은 얼마가 필요한지 등을": "and how much initial capital you would need —",
    "여러분이 직접 확인하시고 건축하세요!": "check it all yourself, then build.",

    // ─────────────────────────────────────────── 랜딩 Section04 / MSection04
    "언제 어디서나, 3D 뷰어": "Anywhere, anytime — 3D viewer",
    "설계한 건축물을 3차원 공간에서 체험하세요.":
        "Walk through your design in three dimensions.",
    "어려운 도면 대신, 3D지만 이미지 대신, 값비싼 뷰어 프로그램 대신!":
        "No hard-to-read drawings, no flat renders, no expensive viewer software.",
    "손쉬운 접근으로 직관적인 내용을 확인할 수 있습니다.":
        "It opens easily, and what you see explains itself.",
    "URL 링크 전달만으로 인터넷이 가능한 곳 어디서든 접속 가능합니다.":
        "Send a link and it opens anywhere with an internet connection.",
    "대면 미팅, VR 체험, 재질 변경 모두 가능합니다.":
        "In-person meetings, VR walkthroughs and material changes are all supported.",
    "지금 바로 확인하세요!": "See it for yourself now.",

    // ─────────────────────────────────────────── 랜딩 Section05 / MSection05
    "집을, 혹은 건물을 짓는데 전문가의 도움 없이는 불가능합니다.":
        "You cannot build a house, or any building, without expert help.",
    "나에게 꼭 맞는 집을 짓기에 필요한 각 분야 전문가들이 상시 대기 중입니다.":
        "Specialists in every field are on hand to help you build the home that fits you.",
    "건축설계, 인허가, 시공, 인테리어, 금융 등":
        "Architecture, permitting, construction, interiors, financing —",
    "해당 전문가에게 직접 물어보고 결정하세요.":
        "ask the right expert directly, then decide.",
    "고객 맞춤의 이해하기 쉽고 단순한 용어로 변환하여 설명해 드립니다.":
        "We explain everything in plain terms, tailored to you.",
    "부담 없이 언제든 연락주세요!": "Get in touch any time — there is no obligation.",

    // ─────────────────────────────────────────── 랜딩 Section06 / MSection06 / Footer
    // ⚠️ 대표·책임자 이름 로마자 표기는 주인님 확인 필요.
    "대표 | 고호준": "CEO | Ko Ho-jun",
    "대표이사 | 고 호 준": "CEO | Ko Ho-jun",
    "개인정보 관리 책임자 | 이형우": "Privacy Officer | Lee Hyoung-woo",
    "개인정보 관리 책임자 | 이 형 우": "Privacy Officer | Lee Hyoung-woo",
    "사업자등록번호 | 469-81-03262": "Business Registration No. | 469-81-03262",
    "회사소개": "About us",
    "이용약관": "Terms of Service",
    "개인정보처리방침": "Privacy Policy",
    "위치기반 서비스 이용약관": "Location-Based Services Terms",
    // ─────────────────────────────────────────── 지도 공통 (util/mapUtil.js)
    "올바른 주소를 입력 혹은 클릭해주세요.": "Enter or click a valid address.",
    "검색 결과가 없습니다.": "No results found.",
    "검색 결과 없음": "No results",
    "검색에 실패하였습니다.": "The search failed.",
    "주소를 찾을 수 없습니다.": "That address could not be found.",
    "주소 오류": "Address error",
    "지오코딩 에러": "Geocoding error",
    "하천은 선택하실 수 없습니다.": "Rivers cannot be selected.",
    "도로는 선택하실 수 없습니다.": "Roads cannot be selected.",
    "실거래가": "Sale price",
    // ─────────────────────────────────────────── 지도 화면 (MapBeta.js)
    "지도를 탐색하여 토지를 선택하거나 주소를 검색해주세요.":
        "Pan the map to pick a parcel, or search for an address.",
    "신축할 필지를 찾아보세요!": "Find a lot to build on.",
    "지적도": "Cadastral map",
    "거리레이어": "Street layer",
    "전체화면": "Full screen",
    "일반": "Standard",
    "위성": "Satellite",
    "로드뷰": "Street View",
    "반경": "Radius",
    "면적": "Area",
    "거리": "Distance",
    "건물 실거래가 조회 금액": "Sale price range",
    "확인": "Confirm",
    // 금액 눈금. 값 자체는 '1억' 그대로 두고 표시만 바꾼다(숫자 파싱이 원문에 의존).
    "1억": "\u20a9100M",
    "5억": "\u20a9500M",
    "10억": "\u20a91B",
    "30억": "\u20a93B",
    "60억": "\u20a96B",

    // 실거래가 마커의 건물 유형 (서버 조회 파라미터 겸 CSS 클래스라 원문은 유지)
    "아파트": "Apartment",
    "오피스텔": "Officetel",
    "공장창고등": "Factory / warehouse",
    "단독다가구": "Detached / multi-household",
    "상업업무용": "Commercial / office",
    "연립다세대": "Row house / multiplex",
    "토지": "Land",
    // ─────────────────────────────────────────── 정보 패널 (InformationBeta.js)
    // 탭
    "토지정보": "Land",
    "건축정보": "Building",
    "예상공사비": "Est. cost",
    "토지평가": "Land rating",
    "가격비교": "Price trend",
    "시뮬레이션": "Simulation",
    "신축정보": "New build",
    "건물정보": "Buildings",
    "AI 분석": "AI analysis",
    "상세": "Details",

    // 개발제한구역 안내 (두 줄이 <br> 로 이어진다)
    "개발제한구역으로": "This is a development-restricted (greenbelt) area \u2014",
    "건축이 불가능한 토지입니다.": "construction is not permitted on this land.",

    // 토지 / 건축 지표
    "토지 면적": "Land area",
    "지목": "Land category",
    "용도": "Zoning",
    "건축가능용도": "Permitted use",
    "공시지가": "Official land price",
    "지형높이": "Terrain height",
    "지형형상": "Terrain shape",
    "데이터기준일자": "Data as of",
    "건축 면적": "Building area",
    "연면적": "Gross floor area",
    "건폐율": "Building coverage ratio",
    "용적률": "Floor area ratio",
    "총액": "Total",
    "설계비": "Design fee",
    "자재비": "Materials",
    "인건비": "Labor",
    "경비": "Overheads",

    // 건물대장
    "건물정보가 없습니다.": "No building information available.",
    "건물정보 {n}": "Building {n}",
    "건물명": "Building name",
    "건물동명": "Block name",
    "건추물구조명": "Structure type",
    "주도용도명": "Main use",
    "건물높이": "Height",
    "지상층수": "Floors above ground",
    "지하층수": "Floors below ground",
    "허가일자": "Permit date",
    "총주차대수": "Parking spaces",
    "총주차장면적": "Parking area",
    "정보 없음": "No data",

    // AI 분석
    "AI 평가 가치": "AI valuation",
    "AI 분석 요약": "AI analysis summary",
    "{amount}원, {percent}%": "\u20a9{amount}, {percent}%",
    "내용을 불러오는중...": "Loading\u2026",
    "가격 비교 정보가 없습니다.": "No price comparison available.",
    "건축 예정일": "Planned build date",
    "건축 용도": "Building use",
    "선택하세요": "Select",
    "시뮬레이션 중...": "Simulating\u2026",
    "시뮬레이션 하기": "Run simulation",
    "추천 구매 시기": "Best time to buy",
    "완공 예정일": "Expected completion",
    "예상 수익률": "Expected return",
    "AI 건축물/토지 찾기": "AI building / land search",
    "AI 분석을 불러오는 중입니다. 잠시만 기달려주세요.":
        "Loading the AI analysis. This will take a moment.",
    "AI 데이터 분석 중 오류가 발생했습니다.":
        "Something went wrong while running the AI analysis.",
    "주소 정보가 없습니다.": "No address selected.",
    "건축 예정일은 YYYY.MM 형식으로 입력하고, 건축 용도를 선택해주세요.":
        "Enter the planned build date as YYYY.MM and choose a building use.",
    "AI 시뮬레이션 중 오류가 발생했습니다.":
        "Something went wrong during the AI simulation.",

    // 북마크
    "전체": "All",
    "북마크를 등록해주세요!": "Add a bookmark to get started.",
    "대지면적": "Site area",
    "견적 비교하기": "Compare estimates",
    "새 리스트 추가": "Add a new list",
    "리스트는 최대 3개까지 입니다.": "You can create up to 3 lists.",
    "새 리스트명을 입력해주세요": "Enter a name for the new list",
    "색상 선택": "Color",
    "리스트 저장": "Save list",
    "토지의 별명을 입력해주세요.": "Give this land a nickname.",
    "새 리스트를 추가해 주세요.": "Please add a list first.",
    "메모": "Note",
    "저장": "Save",

    // 건축용도 가능여부 (allowAble 값은 서버 데이터라 원문을 키로 둔다)
    "건축용도 가능여부": "Permitted uses",
    "건축가능": "Buildable",
    "건축불가": "Not buildable",
    "건축제한": "Restricted",
    "조건부가능": "Conditionally allowed",
    // 배지 폭이 좁아 짧게 쓴다. 전체 문구는 아래 안내문과 토지이음 링크로 안내.
    "[조건·제한·예외사항]": "[Conditions apply]",
    "(조건·제한·예외사항 : {detail})": "(Conditions / limits / exceptions: {detail})",
    "보다 자세한 내용은 토지이음에서 확인해주시길 바랍니다.":
        "For full details, please check Toji-Eum, the national land-use portal.",
    "토지이음 바로가기": "Open Toji-Eum",
    // 조건·제한 원문은 한국어 법령 문구라 외국어 화면에서는 이 안내문으로 대신한다.
    "조건이 붙습니다. 전체 내용은 아래 토지이음에서 확인하세요.": "Conditions apply \u2014 see Toji-Eum below for the full text.",

    // 단위
    "평": " pyeong",
    "(원/㎡)": "(KRW/m\u00b2)",
    "{n}대": "Parking spaces: {n}",
    // ─────────────────────────────────────────── 회사소개 (About.js)
    "건축물사진": "Architecture photo",
    "프롭메이트는 지도 기반으로": "PROPMATE is a map-based service that delivers",
    "토지 관련 모든 정보를 신속하고 정확하게 제공하는 전문 서비스를 자랑합니다.":
        "every piece of land information quickly and accurately.",
    "강력한 데이터베이스와 AI 기술을 바탕으로,": "Backed by a deep database and AI,",
    "고객이 원하는 건물을 지을 수 있는 규모와 예상 비용을 정밀하게 예측합니다.":
        "we forecast precisely how large a building you can put up, and what it will cost.",
    "또한, 건축 가능 용도에 따른 다양한 개발 옵션을 제시하며,":
        "We also lay out the development options for every permitted use,",
    "끊임없이 발전하는 기술과 정보를 통해 고객이 가장 현명한 결정을 내릴 수 있도록 지원합니다.":
        "so that ever-improving technology and data help you make the soundest decision.",
    "항상 고객 만족을 최우선 가치로 삼으며,": "Your satisfaction comes first in everything we do,",
    "함께하는 모든 건축 과정에서 안도감과 신뢰를 제공하는 든든한 파트너가 되겠습니다.":
        "and we aim to be the partner you can rely on at every stage of building.",
    "프롭메이트와 함께라면,": "With PROPMATE,",
    "혁신적인 기술과 신뢰할 수 있는 전문성을 통해 고객의 꿈을 현실로 만들어 드립니다.":
        "innovative technology and dependable expertise turn your plans into reality.",
    "IR파일이미지": "IR document",
    "기업소개서": "Company brochure",
    "회사소개파일이미지": "Company brochure file",
    "회사소개서 언어 선택": "Choose brochure language",
    "한국어": "Korean",
    "한국어 🇰🇷": "Korean 🇰🇷",

    // ─────────────────────────────────────────── AI 토지 찾기 (AiSearchLand.js)
    "AI가 조건에 맞는 토지를 찾고 있습니다...": "AI is looking for land that matches your criteria…",
    "AI 검색이 완료되었습니다!": "AI search complete.",
    "검색 중 오류가 발생했습니다. 다시 시도해주세요.":
        "Something went wrong during the search. Please try again.",
    "{region} 지역의 적합한 토지": "Suitable land in {region}",
    "현재 AI 서비스에 일시적인 문제가 발생했습니다. 부동산 전문가와 상담하시기 바랍니다.":
        "The AI service is temporarily unavailable. Please consult a real-estate professional.",
    "원하는 토지/건축을 찾기 힘드신가요?": "Having trouble finding the right land or building?",
    "AI 토지/건축물 찾기": "AI land & building search",
    "원하는 지역을 선택해주세요.": "Choose the regions you want.",
    "(최대 3개까지 선택 가능)": "(up to 3)",
    "지역을 선택해주세요": "Select a region",
    "AI 토지/건축물 지역 선택 아이콘": "Region selector",
    "예산안을 알려주세요.": "Tell us your budget.",
    "원하는 토지/건축물에 대해 설명해주세요.": "Describe the land or building you want.",
    "ex) 서울, 상업시설, 200평 이상, 10억~30억의 예산안\n'단독주택을 짓고 싶은데 조망이 좋고 조용한 동네면 좋겠어.'":
        "e.g. Seoul, commercial, 200 pyeong or more, budget ₩1B–₩3B\n“I want to build a detached house somewhere quiet with a good view.”",
    "검색 중...": "Searching…",
    "검색하기": "Search",
    "총 {n}건의 토지를 찾았어요!": "Matching sites: {n}",
    "접기": "Collapse",
    "상세 보기": "View details",
    "AI 추천 이유": "Why AI recommends this",
    "다시하기": "Start over",
    // 지역명 (값은 검색 요청에 실려 가므로 원문 유지, 표시만 번역)
    "서울": "Seoul", "부산": "Busan", "대구": "Daegu", "인천": "Incheon",
    "광주": "Gwangju", "대전": "Daejeon", "울산": "Ulsan", "세종": "Sejong",
    "경기도": "Gyeonggi-do", "강원도": "Gangwon-do",
    "충청북도": "Chungcheongbuk-do", "충청남도": "Chungcheongnam-do",
    "전라북도": "Jeollabuk-do", "전라남도": "Jeollanam-do",
    "경상북도": "Gyeongsangbuk-do", "경상남도": "Gyeongsangnam-do", "제주도": "Jeju-do",

    // ─────────────────────────────────────────── 견적 비교 (CmprsEstmt.js)
    "견적 비교할 토지들을 선택해주세요!": "Select the sites you want to compare.",
    "견적 비교를 위해 데이터를 불러오는 중입니다.": "Loading data for the comparison…",
    "예상 공사비": "Est. construction cost",
    "{purpose} 건축 불가": "{purpose} not permitted",
    "건축 가능 용도": "Permitted uses",
    // 건축 용도 (서버의 mainCategoryName 과 비교되는 값이라 원문 유지)
    "단독주택": "Detached house",
    "공동주택": "Multi-unit housing",
    "제1종 근린생활시설": "Class 1 neighborhood facility",
    "제2종 근린생활시설": "Class 2 neighborhood facility",
    "문화 및 집회시설": "Culture & assembly",
    "판매시설": "Retail",
    "운동시설": "Sports",
    "숙박시설": "Lodging",
    "의료시설": "Medical",
    "교육연구시설": "Education & research",
    "노유자시설": "Elderly & childcare",
    "업무시설": "Office",
    "종교시설": "Religious",

    // ─────────────────────────────────────────── 컨설팅 (Consulting.js)
    "컨설팅 받고자 하는 항목들을 선택해주세요. (중복선택 가능)":
        "Choose what you would like advice on. (You can pick more than one.)",
    "컨설팅 받고자하는 건축용도를 입력해주세요. ex)단독주택/다가구주택":
        "Enter the building use you want advice on. e.g. detached house / multi-household",
    "컨설팅 접수가 완료 되었습니다. 영업일 기준 5일이내로 답변 드리겠습니다. 모든 접수는 순차적으로 답변 드립니다. 감사합니다.":
        "Your request has been received. We will reply within 5 business days, in the order received. Thank you.",
    "컨설팅 문의를 보냈습니다.": "Your consulting request has been sent.",
    "중복선택 가능": "You can pick more than one",
    "ex)단독주택/다가구주택": "e.g. detached house / multi-household",
    "컨설팅 항목 선택": "What do you need advice on?",
    "건축 용도 선택": "Building use",
    "건축예산": "Budget",
    "상세 문의": "Your question",
    "컨설팅 받고자 하는 항목들에 대한 설명을 입력해주세요.\r\n \r\n \r\nex)  가지고 있는 땅에 단독 주택을 짓고 싶어요. 자금과 시간이 얼마나 드는지 알고 싶어요.":
        "Tell us more about what you need.\r\n \r\n \r\ne.g.  I want to build a detached house on land I already own. I would like to know what it would cost and how long it would take.",
    // 컨설팅 체크박스 / 예산 (값은 담당자에게 메일로 전달되므로 원문 유지)
    "현재 보고 있는 토지": "The land I'm viewing",
    "설계 / 인허가": "Design / permitting",
    "시공": "Construction",
    "인테리어": "Interiors",
    "예상 공사비 / 예상소요기간": "Estimated cost / timeline",
    "토지 매입": "Land purchase",
    "기타 (상세문의 작성)": "Other (write below)",
    "3억": "₩300M",
    "6억": "₩600M",
    "20억": "₩2B",

    // ─────────────────────────────────────────── 약관 (JoinAgree.js)
    "주소 | 서울시 관악구 문성로 199-1 2층": "Address | 2F, 199-1 Munseong-ro, Gwanak-gu, Seoul",
    "사업자등록번호 | 628-40-00876": "Business Registration No. | 628-40-00876",
    "위치기반서비스": "Location-Based Services",
    "프로모션 정보 수신": "Promotional messages",

    // ─────────────────────────────────────────── 로그인 / 회원가입 (Login.js, Mlogin.js)
    "로그인": "Log in",
    "로그인박스": "Log-in box",
    "회원가입": "Sign up",
    "회원가입박스": "Sign-up box",
    "아이디 찾기": "Find my ID",
    "아이디찾기": "Find my ID",
    "비밀번호 재설정": "Reset password",
    "환영합니다!": "Welcome.",
    "집을 짓기 위한 새로운 여정,": "A new journey to building your home —",
    "프롭메이트와 함께 하세요!": "start it with PROPMATE.",
    "아이디 와 비밀번호를 모두 입력해주세요.": "Please enter both your ID and password.",
    "프롭메이트 아이디 입력": "PROPMATE ID",
    "프롭메이트 비밀번호 입력": "PROPMATE password",
    "카카오로그인버튼": "Kakao login button",
    "카카오로그인": "Log in with Kakao",
    "네이버로그인버튼": "Naver login button",
    "네이버로그인": "Log in with Naver",
    "이메일을 입력해주세요.": "Please enter your email.",
    "이름(기업명)을 입력해주세요.": "Please enter your name (or company name).",
    "전화번호를 입력해주세요.": "Please enter your phone number.",
    "비밀번호를 입력해주세요.": "Please enter a password.",
    "아이디를 입력해주세요.": "Please enter an ID.",
    "회원가입이 완료되었습니다.": "Your account has been created.",
    "아이디 입력": "ID",
    "영문 대소문자와 숫자 4~12자리": "4–12 characters (A–Z, a–z, 0–9)",
    "비밀번호 입력": "Password",
    "영문 대소문자와 숫자 8~20자리": "8–20 characters (A–Z, a–z, 0–9)",
    "비밀번호 확인란을 입력해주세요.": "Please confirm your password.",
    "비밀번호 확인": "Confirm password",
    "비밀번호가 일치하지 않습니다.": "The passwords do not match.",
    "전화번호 입력 (숫자만)": "Phone number (digits only)",
    "이름(기업명) 입력": "Name (or company name)",
    "이메일 입력": "Email",
    "이메일 형식으로 입력해주세요.": "Please enter a valid email address.",
    "선택": "Optional",
    "남자": "Male",
    "여자": "Female",
    "년(4자)": "Year (4 digits)",
    "--월": "-- Month",
    "1월": "January", "2월": "February", "3월": "March", "4월": "April",
    "5월": "May", "6월": "June", "7월": "July", "8월": "August",
    "9월": "September", "10월": "October", "11월": "November", "12월": "December",
    "일": "Day",
    "직업 선택": "Select occupation",
    "예비 건축주": "Prospective owner-builder",
    "건축업 종사자": "Construction professional",
    "프롭메이트 정보수집에 모두 동의합니다.": "I agree to all of PROPMATE's data terms.",
    "프롭메이트 이용약관 동의": "Agree to the PROPMATE Terms of Service",
    "필수": "Required",
    "자세히보기": "Read more",
    "개인정보 수집 및 이용 동의": "Agree to the collection and use of personal data",
    "위치기반서비스 이용약관 동의": "Agree to the Location-Based Services terms",
    "프로모션 정보 수신 동의": "Agree to receive promotional messages",
    "가입한 이메일 입력": "The email you signed up with",
    "가입한 아이디 입력": "The ID you signed up with",
    "이메일에 인증번호를 보냈습니다.": "We have emailed you a verification code.",
    "인증완료.": "Verified.",
    "인증에 실패했습니다. 다시 인증요청 해주시길 바랍니다.":
        "Verification failed. Please request a new code.",
    "비밀번호 변경완료": "Your password has been changed.",
    "인증요청": "Send code",
    "인증번호": "Verification code",
    "인증번호 입력": "Enter the code",
    "인증확인": "Verify",

    // ─────────────────────────────────────────── 마이페이지 (Mypage.js)
    "입력안함": "Not provided",
    "내 정보": "My profile",
    "정보 수정": "Edit profile",
    "내정보 수정 박스": "Edit profile box",
    "수정완료": "Save",
    "취소": "Cancel",
    "닉네임변경": "Change nickname",
    "닉네임변경완료버튼": "Confirm nickname change",
    "이메일을 입력해 주세요.": "Please enter your email.",
    "핸드폰 번호를 입력해 주세요.": "Please enter your mobile number.",
    "이름을 입력해 주세요.": "Please enter your name.",
    "성별을 선택해 주세요.": "Please select your gender.",
    "생년월일을 입력해 주세요.": "Please enter your date of birth.",
    "직업을 선택해 주세요.": "Please select your occupation.",
    "직업을 선택해 주세요": "Select your occupation",
    "개인정보 이용내역": "Personal data usage",
    "조회": "View",
    "북마크": "Bookmarks",
    "대지면적  :": "Site area  :",
    "지도페이지로이동": "Go to the map",
    "지도에서 북마크를 등록해주세요!": "Add bookmarks from the map.",
    "지도 바로가기": "Open the map",
    "삭제하기": "Delete",
    "수정하기": "Edit",

    // ─────────────────────────────────────────── 뉴스 (News.js)
    "뉴스를 불러오는 중...": "Loading news…",
    "등록된 뉴스가 없습니다.": "No news yet.",
    "이전": "Previous",
    "다음": "Next",

    // ─────────────────────────────────────────── 차트 (MyChart.js, PriceForecastChart.js, RadarChartComponent.js)
    "공시지가 (만원/㎡)": "Official land price (10k KRW/m²)",
    "5개년 공시지가 그래프": "Official land price, last 5 years",
    "AI 예측 5년 후 평당 가격 (단위: 원)": "AI 5-year forecast — price per pyeong (KRW)",
    "AI 평당 가격 예측 그래프": "AI price-per-pyeong forecast",
    "{amount}원": "₩{amount}",
    "{amount}원 ({percent}%)": "₩{amount} ({percent}%)",
    "변동 없음": "No change",
    "최저가": "Low",
    "최고가": "High",
    "토지가격": "Land price",
    "투자가치": "Investment value",
    "법적 규제": "Regulation",
    "소음": "Noise",
    "인구 규모": "Population",
    "교통 및 접근성": "Transit & access",
    "지형 및 토양": "Terrain & soil",
    "편의시설": "Amenities",
    "인프라 및 공공시설": "Infrastructure",
    "평가": "Rating",
    "{n}점": "{n} pts",

    // ─────────────────────────────────────────── 프로젝트 (Project.js)
    "3D웹사이트 보러가기": "Visit the 3D site",
    // ─────────────────────────────────────────── 글쓰기 에디터 (Draft.js)
    "게시글을 작성해주세요": "Write your post",
    // ─────────────────────────────────────────── 팀 소개 (People.js)
    "건축의 시작이,\n더 이상 전문가만의 영역이 아니길 바란다.":
        "May the start of building\nno longer belong to specialists alone.",
    "#건축가 #창업가 #유튜버": "#architect #founder #youtuber",
    "나는 방향을 설계하고,\n팀은 파도를 만든다.":
        "I design the direction,\nthe team makes the waves.",
    "#분위기메이커 #햇살캐 #꺄르르": "#moodmaker #sunshine #giggles",
    "설계는 정답이 없지만 오답은 있다.":
        "Design has no right answer, but it does have wrong ones.",
    "#건축가 #궁수 #클라이머": "#architect #archer #climber",
    "불가능한 개발은 없다.\n노력이 필요할 뿐.":
        "No build is impossible.\nIt only takes work.",
    "#풀스택 #천재개발자 #플러팅장인": "#fullstack #geniusdev #flirtmaster",
    "모든 것은 ‘기획’으로 시작된다.": "Everything starts with the plan.",
    "#기획 #감정미적분기 #유빈씨,,바빠요?": "#planning #emotioncalculus #yubin-you-busy?",
    "버그보다 골절이 먼저 왔다.": "The fracture came before the bug.",
    "#풀스택 #술자바(Sul.js) #손가락404": "#fullstack #Sul.js #finger404",
    "데이터는 쿨하게,\n분석은 뜨겁게.": "Cool with the data,\nhot with the analysis.",
    "#데이터개발자 #동자승 #오픈런러": "#datadev #littlemonk #openrunner",
    "오류는 고쳐도,\n자세는 못 고친다.": "I can fix the errors,\nnot my posture.",
    "#풀스택 #허리404 #래블래용": "#fullstack #spine404 #raeblaeyong",
    "디자인은 디테일,\n회식은 타이밍.": "Design is detail,\ndinner is timing.",
    "#디자이너 #회식탐지기 #피그마의광대": "#designer #dinnerradar #figmaclown",

    // ─────────────────────────────────────────── 보도자료 제목 (News.js)
    // 제목은 서버에서 내려오므로, 사전에 없는 새 기사는 한국어로 노출된다.
    "투명하고 똑똑한 IT 건축 플랫폼 '프롭메이트' 부동산 개발의 새로운 패러다임 열다":
        "PROPMATE, a transparent and intelligent IT construction platform, opens a new paradigm in property development",
    "프롭메이트, '2024 대한민국 지식재산대전'에서 AI 토지정보 제공 시스템 선봬":
        "PROPMATE unveils its AI land-information system at the 2024 Korea Intellectual Property Exhibition",
    "프롭메이트, 'NIPA 지역 성과보고회' 성공적 참여":
        "PROPMATE takes part in NIPA's regional results briefing",
    "프롭메이트, AIoT 국제전시회에서 혁신적 솔루션을 선보이다.":
        "PROPMATE presents its innovative solution at the AIoT International Exhibition",
    "프롭메이트, 2024 AIoT 국제전시회 참가... 토지 정보 제공 시스템·3D 가상 시뮬레이션 기술 알린다":
        "PROPMATE joins the 2024 AIoT International Exhibition, showcasing its land-information system and 3D simulation technology",
    // ════════════════════════════════════════════════════════════════
    // 서버가 돌려주는 법정 용어들. 값 자체는 비교·전송에 쓰이므로 원문을 유지하고
    // 화면에 뿌릴 때만 t() 로 변환한다. 사전에 없는 값은 한국어가 그대로 보인다.
    // ════════════════════════════════════════════════════════════════

    // ── 지목 (land.type) ──
    "대": "Building site", "대지": "Building site",
    "전": "Dry field", "답": "Rice paddy", "과수원": "Orchard",
    "목장용지": "Pasture", "임야": "Forest", "광천지": "Mineral spring",
    "염전": "Salt pond", "공장용지": "Factory site", "학교용지": "School site",
    "주차장": "Parking lot", "주유소용지": "Petrol station site",
    "창고용지": "Warehouse site", "도로": "Road", "철도용지": "Railway site",
    "제방": "Embankment", "하천": "River", "구거": "Ditch", "유지": "Reservoir",
    "양어장": "Fish farm", "수도용지": "Waterworks site", "공원": "Park",
    "체육용지": "Sports facility site", "유원지": "Amusement park",
    "종교용지": "Religious site", "사적지": "Historic site", "묘지": "Cemetery",
    "잡종지": "Miscellaneous land",

    // ── 용도지역 (land.landType1 / zoning) ──
    "제1종전용주거지역": "Type 1 exclusive residential",
    "제2종전용주거지역": "Type 2 exclusive residential",
    "제1종일반주거지역": "Type 1 general residential",
    "제2종일반주거지역": "Type 2 general residential",
    "제3종일반주거지역": "Type 3 general residential",
    "준주거지역": "Semi-residential",
    "중심상업지역": "Central commercial",
    "일반상업지역": "General commercial",
    "근린상업지역": "Neighbourhood commercial",
    "유통상업지역": "Distribution commercial",
    "전용공업지역": "Exclusive industrial",
    "일반공업지역": "General industrial",
    "준공업지역": "Semi-industrial",
    "보전녹지지역": "Conservation green",
    "생산녹지지역": "Production green",
    "자연녹지지역": "Natural green",
    "보전관리지역": "Conservation management",
    "생산관리지역": "Production management",
    "계획관리지역": "Planned management",
    "농림지역": "Agricultural & forestry",
    "자연환경보전지역": "Nature conservation",
    "개발제한구역": "Development-restricted (greenbelt)",

    // ── 지형형상 (land.landFromCode) ──
    "정방형": "Square", "가장형": "Rectangular (wide)", "가로장방형": "Rectangular (wide)",
    "세로장방형": "Rectangular (deep)", "사다리형": "Trapezoidal", "부정형": "Irregular",
    "자루형": "Flag-shaped", "삼각형": "Triangular", "역삼각형": "Inverted triangular",

    // ── 건축물 대분류 21종 (mainCategoryName / allowBuildingListSubCategory.name) ──
    // 단독주택·공동주택 등 13종은 위 CmprsEstmt 절에 이미 있다.
    "수련시설": "Training facility",
    "창고시설": "Warehouse",
    "위험물 저장 및 처리 시설": "Hazardous material storage & handling",
    "자동차 관련 시설": "Vehicle-related facility",
    "동물 및 식물 관련 시설": "Animal & plant facility",
    "교정 및 군사 시설": "Correctional & military facility",
    "방송통신시설": "Broadcasting & telecoms facility",
    "묘지 관련 시설": "Cemetery-related facility",
    // ── 세부 토지이용명 (allowBuildingListSubCategory[].list[].토지이용명) ──
    // 건축법 시행령 별표1 의 용도 세부 항목. 원문 끝의 「。」 는 떼고 들어온다.
    "결혼상담소": "Marriage agency",
    "고등학교": "High school",
    "골프연습장": "Golf driving range",
    "골프장": "Golf course",
    "공공도서관": "Public library",
    "공관": "Official residence",
    "공중화장실": "Public toilet",
    "공회당": "Assembly hall",
    "과학관": "Science museum",
    "교습소": "Tutoring centre",
    "교회": "Church",
    "구기장": "Ball-game court",
    "국방시설": "Defence facility",
    "군사시설": "Military facility",
    "궁도장": "Archery range",
    "극장": "Theatre",
    "근로복지시설": "Workers' welfare facility",
    "금융업소": "Financial office",
    "기념관": "Memorial hall",
    "기도원": "Prayer retreat",
    "기숙사": "Dormitory",
    "기원": "Baduk club",
    "노래연습장": "Karaoke room",
    "노인복지시설": "Senior welfare facility",
    "놀이형시설": "Play facility",
    "농수산물공판장": "Agri-fisheries auction market",
    "농수산물도매시장": "Agri-fisheries wholesale market",
    "다가구주택": "Multi-household house",
    "다세대주택": "Multiplex housing",
    "다중생활시설": "Shared living facility",
    "다중주택": "Multi-user house",
    "당구장": "Billiard hall",
    "대규모점포": "Large retail store",
    "대피소": "Shelter",
    "대학교": "University",
    "데이터센터": "Data centre",
    "도시가스배관시설": "City gas pipeline facility",
    "독서실": "Study room",
    "동물미용실": "Pet grooming salon",
    "동물병원": "Veterinary clinic",
    "동물원": "Zoo",
    "롤러스케이트장": "Roller rink",
    "마을공동구판장": "Village co-op store",
    "마을공동작업소": "Village workshop",
    "마을회관": "Village hall",
    "목욕장": "Public bath",
    "문화관": "Cultural centre",
    "미술관": "Art museum",
    "미용원": "Beauty salon",
    "박람회장": "Exhibition hall",
    "박물관": "Museum",
    "방송국": "Broadcasting station",
    "변전소": "Substation",
    "보건소": "Public health centre",
    "복합유통게임제공업소": "Multiplex game arcade",
    "볼링장": "Bowling alley",
    "봉안당(奉安堂)": "Charnel house",
    "부동산중개사무소": "Real-estate agency",
    "비디오물감상실": "Video viewing room",
    "비디오물소극장": "Small video theatre",
    "사격장": "Shooting range",
    "사당": "Shrine",
    "사무소": "Office",
    "사진관": "Photo studio",
    "사찰": "Buddhist temple",
    "사회복지시설": "Social welfare facility",
    "산업전시장": "Industrial exhibition hall",
    "산후조리원": "Postpartum care centre",
    "상점": "Shop",
    "서점": "Bookshop",
    "서커스장": "Circus venue",
    "성당": "Catholic church",
    "세차장": "Car wash",
    "세탁소": "Laundry",
    "소방서": "Fire station",
    "수녀원": "Convent",
    "수도원": "Monastery",
    "수리점": "Repair shop",
    "수영장": "Swimming pool",
    "수족관": "Aquarium",
    "스케이트장": "Ice rink",
    "승마장": "Riding ground",
    "식물원": "Botanical garden",
    "실내낚시터": "Indoor fishing pond",
    "아동복지시설": "Child welfare facility",
    "안마원": "Massage parlour",
    "양수장": "Pumping station",
    "어린이집": "Daycare centre",
    "에어로빅장": "Aerobics studio",
    "연구소": "Research institute",
    "연립주택": "Row house",
    "연수원": "Training institute",
    "연예장": "Entertainment venue",
    "영화관": "Cinema",
    "예식장": "Wedding hall",
    "요양병원": "Convalescent hospital",
    "우체국": "Post office",
    "유스호스텔": "Youth hostel",
    "유치원": "Kindergarten",
    "육상장": "Athletics track",
    "음악당": "Concert hall",
    "의원": "Clinic",
    "이용원": "Barber shop",
    "인터넷컴퓨터게임시설제공업소": "Internet café",
    "일반음식점": "Restaurant",
    "자동차영업소": "Car dealership",
    "장의사": "Funeral parlour",
    "전문대학": "Junior college",
    "전신전화국": "Telecom office",
    "접골원": "Bonesetting clinic",
    "정수장": "Water treatment plant",
    "정신병원": "Psychiatric hospital",
    "제과점": "Bakery",
    "제실": "Ancestral shrine",
    "제조업소": "Manufacturing workshop",
    "조산원": "Midwifery clinic",
    "종묘배양시설": "Seedling culture facility",
    "종합병원": "General hospital",
    "주유소": "Petrol station",
    "중학교": "Middle school",
    "지구대": "Police substation",
    "지역아동센터": "Community child centre",
    "지역자치센터": "Community service centre",
    "직업훈련소": "Vocational training centre",
    "차고": "Garage",
    "청소년게임제공업소": "Youth game arcade",
    "청소년문화의집": "Youth cultural centre",
    "청소년수련관": "Youth training hall",
    "청소년수련원": "Youth training centre",
    "청소년야영장": "Youth campsite",
    "청소년특화시설": "Specialised youth facility",
    "체력단련장": "Fitness centre",
    "체육관": "Gymnasium",
    "체육도장": "Martial-arts studio",
    "체험관": "Experience centre",
    "초등학교": "Primary school",
    "총포판매소": "Firearms shop",
    "촬영소": "Film studio",
    "출판사": "Publisher",
    "치과병원": "Dental hospital",
    "치과의원": "Dental clinic",
    "침술원": "Acupuncture clinic",
    "탁구장": "Table-tennis hall",
    "테니스장": "Tennis court",
    "파출소": "Police box",
    "표구점": "Framing shop",
    "하역장": "Loading yard",
    "학원": "Private academy",
    "한방병원": "Oriental medicine hospital",
    "한의원": "Oriental medicine clinic",
    "회의장": "Conference hall",
    "휴게음식점": "Snack bar",
    // ─────────────────────────────────────────── 원래 영어로 박혀 있던 메뉴·폼 라벨
    // 영어 화면은 원문 그대로 두고, 독일어·핀란드어 사전에서만 번역한다.
    "Log In": "Log In",
    "Log Out": "Log Out",
    "About": "About",
    "People": "People",
    "News": "News",
    "My page": "My page",
    "ID": "ID",
    "Password": "Password",
    "Phone Number": "Phone Number",
    "PhoneNumber": "PhoneNumber",
    "Phone": "Phone",
    "Email": "Email",
    "EMAIL": "EMAIL",
    "Gender": "Gender",
    "Birthday": "Birthday",
    "Occupational": "Occupational",
    "Occupation": "Occupation",
    "Download": "Download",
    "Introduction": "Introduction",
    "English": "English",
    "SCORE": "SCORE",
    "Loading...": "Loading...",
};

export default en;
